import barra from '../../general/barra/barra.vue'
import barrais from '../../general/barrais/barrais.vue'
import contenedor from './contenedor/contenedor.vue'
import foot from '../../general/foot/foot.vue'
import barrade from '../../general/barrade/barrade.vue'

export default {
  name: 'resumenvtatarjeta',
  data() {
    return {
      msg: '-'
    }
  },

  components: {
    barra,
    barrais,
    contenedor,
    foot,
    barrade
  }
}



// WEBPACK FOOTER //
// ./src/components/estadisticas/resumenvtatarjeta/resumenvtatarjeta.js